<template>
  <div class="contact-page">
    <h1 v-html="focus.cartouche ? focus.cartouche.titre : ''"></h1>
    <p v-html="focus.cartouche ? focus.cartouche.texte : '' "></p>
    <div v-if="formSent" v-html="focus.paragraphe2 ? focus.paragraphe2.texte : ' '"></div>
    <form v-else @submit.stop.prevent="sendData" class="contact-page-form">
      <div>
        <div class="contact-page-form-field-container">
          <input id="name" name="name" placeholder="Votre nom" v-model="fiche.nom" required />
          <label for="name">Nom</label>
        </div>
        <div class="contact-page-form-field-container">
          <input id="surname" name="surname" placeholder="Votre prénom" v-model="fiche.prenom" required />
          <label for="surname">Prénom</label>
        </div>
        <div class="contact-page-form-field-container">
          <input id="email" name="email" type="email" placeholder="Votre email" v-model="fiche.email" required />
          <label for="email">Email</label>
        </div>
        <div class="contact-page-form-field-container">
          <input id="telephone" name="telephone" placeholder="Votre téléphone" v-model="fiche.telephone" />
          <label for="telephone">Téléphone</label>
        </div>
        <div class="contact-page-form-field-container">
          <input id="adresse" name="adresse" placeholder="Votre Adresse" v-model="fiche.adresse" />
          <label for="adresse">Adresse</label>
        </div>
        <div class="contact-page-form-field-container">
          <input id="cp" name="cp" placeholder="Votre code postal" v-model="fiche.codePostal" />
          <label for="cp">Votre code postal</label>
        </div>
        <div class="contact-page-form-field-container">
          <AutoCompleteGouvApi intitule="ville" :ville="fiche.ville" :cp="fiche.codePostal"
            @changedGPSData="changeGPSData">
          </AutoCompleteGouvApi>
          <label for="ville">Ville</label>
        </div>
        <div class="contact-page-form-field-container">
          <AutoCompleteGouvApi intitule="pays" :pays="fiche.pays" autoCompType="pays" @changedGPSData="changeGPSData">
          </AutoCompleteGouvApi>
          <label for="pays">Pays</label>
        </div>
      </div>
      <div class="contact-page-form-second-container">
        <div class="contact-page-form-field-container">
          <textarea id="questions" name="questions" placeholder="Vos questions" v-model="fiche.questions" rows="10"
            cols="40"></textarea>
          <label for="questions">Vos questions</label>
        </div>
        <div class="contact-page-form-rgpd-container">
          <input type="checkbox" id="conditionsRgpd" name="conditionsRgpd" placeholder="Vos questions"
            v-model="fiche.rgpd" required />
          <p v-html="focus.paragraphe1 ? focus.paragraphe1.texte : ' '"></p>
        </div>
        <div class="contact-page-form-submit-container">
          <strong>* Champs obligatoires</strong>
          <input type="submit" id="envoyer" value="Envoyer" class="cg-btn cg-btn-primary" />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import DataApi from '../../dependencies/index'
import { getFocus } from '../../mixins/getFocus'


export default {
  name: 'ImmoContact',
  mixins: [getFocus],
  props: {
    siteCode: String
  },
  components: {
    AutoCompleteGouvApi: () => import('../../components/AutoCompleteGouvApi')
  },
  data() {
    return {
      fiche: {
        nom: '',
        prenom: '',
        email: '',
        telephone: '',
        adresse: '',
        codePostal: '',
        ville: '',
        pays: '',
        questions: '',
        rgpd: '',
        type: 'contact',
        destinataire: this.siteCode
      },
      formSent: false,
      focus: {}
    }
  },
  methods: {
    async sendData() {
      const demandeToSend = this.fiche
      demandeToSend.rgpd = + demandeToSend.rgpd
      const options = {
        apiUrl: this.$apiUrl,
        databaseName: this.$databaseName,
        token: await this.$getMainToken()
      }
      this.dataApi = new DataApi(options)
      this.dataApi.createRecord(
        'W_DemandeContact',
        demandeToSend,
        [{
          name: 'validerFormulaire',
          type: 'postrequest'
        }]
      )
        .then((response) => {
          console.log(response)
          this.formSent = true
        })
    },
    changeGPSData(data) {
      if (data.commune) {
        this.fiche.ville = data.commune.value
      }
      if (data.pays) {
        this.fiche.pays = data.pays.value
      }
    }
  },
  async beforeMount() {
    await this.getFocus(this.siteCode, 'Contact')
      .then(res => {
        this.focus = res
      })
  }
}
</script>
<style lang="scss" scoped>
.contact-page {
  max-width: var(--max-width);
  width: 100%;
  margin: 48px 0;
  background: white;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 2px 3px 10px 0 rgba(0, 0, 0, 0.2);

  .contact-page-form {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;

    .contact-page-form-second-container {
      flex-grow: 1;
    }

    .contact-page-form-field-container {
      display: flex;
      flex-direction: column-reverse;
      align-items: flex-start;
      margin: 16px;

      input {
        height: 48px;
        width: 250px;
      }

      input,
      textarea {
        padding: .5rem 1rem;
        line-height: 1.5;
        border-radius: .3rem;
        border: 1px solid #ced4da;
        font-size: 0.8rem;
        font-weight: 600;

        &::placeholder {
          color: #C0C4CC;
        }
      }

      textarea {
        width: 100%;
      }

      input:focus-visible,
      textarea:focus-visible {
        outline: 2px solid var(--color-primary);
      }

      label {
        margin: 0;
      }

      *:required~label::after {
        content: '*';
      }
    }

    .contact-page-form-rgpd-container {
      display: flex;
      margin: 16px;

      p {
        max-width: 500px;
        margin: 16px;
      }
    }

    .contact-page-form-submit-container {
      margin: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .cg-btn {
      height: 50px;
      width: 250px;
      display: block;
      margin: 16px;
    }
  }
}
</style>
